module.exports = "export default __webpack_public_path__ + \"../../transfer.html\";";